import { useMemo } from 'react'
import { getTourTags, LuxPlusLabelTagOptions } from 'lib/tours/tourUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusToursEnabled } from 'checkout/selectors/tourV2Selectors'

function useTourTags(
  tour: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary,
  luxPlusLabels: LuxPlusLabelTagOptions = 'all',
  departureId?: string,
) {
  const isLuxPlusToursAvailable = useAppSelector(state => getIsLuxPlusToursEnabled(state))
  return useMemo(() => getTourTags(
    tour,
    isLuxPlusToursAvailable,
    luxPlusLabels,
    departureId,
  ), [tour, isLuxPlusToursAvailable, luxPlusLabels, departureId])
}

export default useTourTags
